import { useState, useEffect } from "react";
import { Navbar, Nav, NavDropdown, Container, Button } from "react-bootstrap";
import "./header.css";
import logo from "../../Images/deepthi.png";
import { Link, useNavigate } from "react-router-dom";
import svgimg from "../../Images/pattern.svg";

function Header() {
  const [index, setIndex] = useState(0);
  const totalSlides = 3;
  const [showDropdown, setShowDropdown] = useState(false);

  const navigate = useNavigate(); // Used for navigation

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % totalSlides);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const handleDonateClick = () => {
    navigate("/donate");
  };

  return (
    <div className="landing-page">
      {/* Navbar */}
      <Navbar expand="lg" className="navbar-custom">
        <Container>
          <Navbar.Brand href="/" className="brand-wrapper">
            <img
              src={logo}
              alt="DEEPTI SPECIAL SCHOOL & REHABILITATION CENTER"
              className="logo"
            />
            <div className="logo-text">Enabling the present - Enlightening the future</div>
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link href="/">HOME</Nav.Link>
              <Nav.Link href="/about-us">ABOUT US</Nav.Link>

              {/* Dropdown for Services */}
              <Nav.Link href="/services">SERVICES</Nav.Link>

              <Nav.Link href="/admission">ADMISSIONS</Nav.Link>
              <Nav.Link href="/events">EVENTS & ACTIVITIES</Nav.Link>
              {/* <Nav.Link href="/gallery">GALLERY</Nav.Link> */}
              <Nav.Link href="/reach-us">CONTACT</Nav.Link>

              {/* Donate Now Button */}
              <Button className="donate-now-btn" onClick={handleDonateClick}>
                DONATE NOW
              </Button>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
}

export default Header;

{
  /* <img src={svgimg} alt="" /> */
}
